/* eslint-disable */
import axios from "axios";
import jwt_decode from "jwt-decode";
import store from "../../store/index";
import VuePdfEmbed from 'vue-pdf-embed'
import moment from "moment";
export default {
    name: "f4p",
    components:{
        VuePdfEmbed
    },
    data(){
        return{
            baseurl: process.env.VUE_APP_Service_URL,
            fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
            selectedFile:"",
            selectedstudy:"",
            totalPages: 0,
            currentPage: 1,
            pagePositions: [],
            studylist:[],
            downloadName:"",
            source:"",
            officeurl:"",
            documentRefId:"",
            documentVersion:"",
            organizationId:"",
            documentTitle:"",
            documentDescription:"",
            studyFiles: [],  
            soaPages:"",
            validations:[false,false],
            showLoading:false,
            showSoaPageValidation:false,
            showValidation:false,
            showCancel:false,
            dragActive: false,
            readyToView: false,
            fileUploaded:false,
            importLoader:false,
            isLandscape: false,
        }
    },
    beforeMount() {
        store.dispatch("setNavbar", false);
        document.getElementById("page-wrapper").style.width = "100%";
    },
    methods: {
     onPdfLoaded(pdf) {
    // pdf is the PDF.js proxy object
    this.totalPages = pdf.numPages || 0;
    this.currentPage = 1;

    // After initial render, compute current page once
    this.$nextTick(() => {
      this.updateCurrentPageFromScroll();
    });
  },

  onPdfScroll() {
    this.updateCurrentPageFromScroll();
  },

  updateCurrentPageFromScroll() {
    const container = this.$refs.pdfContainer;
    if (!container) return;

    const anchors = container.querySelectorAll('.pdf-page-anchor');
    if (!anchors.length) return;

    const containerRect = container.getBoundingClientRect();
    const header = container.querySelector('.pdf-page-summary');
    const headerHeight = header ? header.offsetHeight : 0;

    const targetY = containerRect.top + headerHeight + 1;

    let nearestPage = this.currentPage;
    let smallestDistance = Infinity;

    anchors.forEach((anchor) => {
      const rect = anchor.getBoundingClientRect();
      const distance = Math.abs(rect.top - targetY);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        nearestPage = Number(anchor.dataset.page) || 1;
      }
    });

    this.currentPage = nearestPage;
  },


  goToPrevPage() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
    }
  },

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
    }
  },
    async getstudy() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/study/getallstudy`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.studylist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
        },
        previewFiles(event) {
            console.log("entered preview",event)
            this.fileUploaded=false
            this.showValidation = false
            this.studyFiles = Array.from(event.target.files);
            if(this.studyFiles && this.studyFiles.length!=0){
                this.fileUploaded=true              
            }
        },
        async protocolExport() {
            if (this.studyFiles.length == 0) {
                this.showValidation = true
                this.readyToView=false
            }
            else {
                this.showLoading = true;
                this.showValidation = true;
                await this.CreateDocumentDMS();
            }
        },
        async uploadData() {
            this.showValidation = false;
            const formData = new FormData();
            this.studyFiles.forEach((file) => {
                formData.append("file", file);
            });
           
            try {
                const response = await axios.post(
                    `${this.baseurl}/forms-ml/studyprotocol/studyprotocoltoexcel`, formData,                    
                );
                this.dataInput = response.headers['xlid'];
                this.documentTitle = this.studyFiles[0].name.replace(/\.pdf$/, '');  
                const jsonData = JSON.stringify(response.data, null, 2); // Pretty-print JSON
                const blob = new Blob([jsonData], { type: 'application/json' });
                await this.CreateDocumentDMS()
             
                this.showLoading=false
            } catch (err) {
                this.showLoading=false
                console.log("Error in file upload...", err);
                this.protocolDetails.status = "Upload failed in datalake"
               
            }
        },
         async CreateDocumentDMS(){
            this.showValidation = false;
            this.documentDescription ="This is the uploaded study protocol file saved to DMS."
            const dmsFormData = new FormData();
         
            [...this.studyFiles].forEach((file) => {
                dmsFormData.append("Document", file);
            });
 
            dmsFormData.append("DocumentTypeName", "STUDY_PROTOCOL");
            dmsFormData.append("DocumentTitle", this.documentTitle);
            dmsFormData.append("DocumentDescription", this.documentDescription);
            dmsFormData.append("OrganizationId", this.organizationId);
 
           try {
            const response = await axios.post(
                `${this.baseurl}/dms/document/create`,
                dmsFormData,
                {
                headers: {
                    Authorization: "Bearer " + this.idToken,
                    "Content-Type": "multipart/form-data",
                },
                }
            );
 
            this.documentRefId = response.data.data[0];
            this.documentVersion = response.data.data[1];
            this.showLoading=false
            await this.setdoc();
            } catch (err) {
                this.showLoading=false
            console.log("error", err);
            this.protocolDetails.status = "Upload failed in DMS";
            }
             
        },
        async setdoc() {
                this.source = `${this.fileuploadurl}/file/${this.documentRefId}?versionid=${this.documentVersion}`;      
                this.readyToView=true      
                this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.source}`
        },
        async importSoA() {
            // Validation
            if (!this.studyFiles || this.studyFiles.length === 0) {
                this.showValidation = true;
                return;
            }
            if (this.soaPages === "") {
                this.showSoaPageValidation = true;
                return;
            }
 
            this.showSoaPageValidation = false;
            this.showValidation = false;
            this.importLoader = true;
 
            const soaFileImport = new FormData();
 
            // Append multiple files
            this.studyFiles.forEach((file) => {
                soaFileImport.append("file", file);
            });
 
            // Append inputs
            soaFileImport.append("page_numbers", this.soaPages);
            soaFileImport.append("study", this.selectedstudy);
            soaFileImport.append("isLandscape", this.isLandscape ? "true" : "false");
 
            try {
                var idToken = store.getters.getIdToken
                const response = await axios.post(
                    `${this.baseurl}/soa-extraction-py/soaextraction/upload-pdf`,
                    soaFileImport,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": `Bearer ${idToken}`,
                        },
                        responseType: "blob",
                    }
                );
 
                // Extract filename from response
                const match = response.headers["content-disposition"]?.match(/filename="?([^"]+)"?/);
                const fileName = match ? match[1] : "download.xlsx";
 
                // Create Blob and download
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
 
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
 
                // Cleanup
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
 
                // Reset form
                this.studyFiles = [];
                this.$refs.inputProtocol.value = null;
                this.soaPages = "";
                this.selectedstudy = "";
                this.isLandscape = false;
 
                alert(this.$t("navigations.soa extracted successfully"));
            } catch (err) {
                alert("SoA extraction failed — only text-based PDFs with 'x', '-----', or '.' line tables are supported.")
                console.error("Error uploading or downloading:", err);
                this.protocolDetails.status = "Upload failed in DMS";
            } finally {
                this.importLoader = false;
            }
        }
    }
}
